import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const variablesService = {
  // Variables
  getAllVariables: (params) => axiosInstance.get(API_ENDPOINTS.Variable.GET_ALL_VARIABLES, {
    params: params,
  }),
  createVariable: (data) => axiosInstance.post(API_ENDPOINTS.Variable.CREATE_VARIABLE, data),
  updateVariable: (id, data) => axiosInstance.put(API_ENDPOINTS.Variable.UPDATE_VARIABLE(id), data),
  deleteVariable: (id) => axiosInstance.delete(API_ENDPOINTS.Variable.DELETE_VARIABLE(id)),

  // Variable Types
  getAllVariableTypes: (params) => axiosInstance.get(API_ENDPOINTS.VariableType.GET_ALL_VARIABLE_TYPES, {
    params: params,
  }),
  createVariableType: (data) => axiosInstance.post(API_ENDPOINTS.VariableType.CREATE_VARIABLE_TYPE, data),
  updateVariableType: (id, data) => axiosInstance.put(API_ENDPOINTS.VariableType.UPDATE_VARIABLE_TYPE(id), data),
  deleteVariableType: (id) => axiosInstance.delete(API_ENDPOINTS.VariableType.DELETE_VARIABLE_TYPE(id)),
};

export default variablesService;
